import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../react-query/constant";
import getProvince from "../api/province";

const useProvinceInfo = () => {
    return useQuery([queryKeys.province], getProvince, {
        onError: (error) => console.log(error),
        cacheTime: Infinity,
        staleTime: Infinity
    });
};
export default useProvinceInfo;